import React from 'react'
import PropTypes from 'prop-types'

import { Count, FacetContainer } from '../../../components/CustomRefinementList/styled'
import Checkbox from '../../Checkbox'
import { formatNumberWithUnit } from '../../../Helpers'

const CheckboxFacet = ({ name, handleFacetClick, value, isMobile, isFacetIdEnabled }) => {
  return (
    <FacetContainer
      data-testid={`facet-container-${name}-${value.name}`}
      isMobile={isMobile}
      onClick={() =>
        handleFacetClick({
          facet: name,
          facetValue: value.name,
          facetCount: value.count,
          ...(isFacetIdEnabled && { facetId: value.id }),
        })
      }
    >
      <Checkbox value={value.name} checked={value.checked} />
      <Count>{formatNumberWithUnit(value.count)}</Count>
    </FacetContainer>
  )
}

export default CheckboxFacet

CheckboxFacet.defaultProps = {
  isMobile: false,
  isFacetIdEnabled: true,
}

CheckboxFacet.propTypes = {
  name: PropTypes.string.isRequired,
  handleFacetClick: PropTypes.func.isRequired,
  value: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    checked: PropTypes.bool,
  }).isRequired,
  isMobile: PropTypes.bool,
  isFacetIdEnabled: PropTypes.bool,
}
